import { Component, inject, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SidebarService } from '../../services/sidebar.service';
import { AuthService } from '../../services/auth.service';
import { ChangePasswordModalComponent } from '../change-password-modal/change-password-modal';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, ChangePasswordModalComponent],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.scss'
})
export class SidebarComponent {
  protected sidebarService = inject(SidebarService);
  protected authService = inject(AuthService);
  protected isPasswordModalOpen = signal(false);

  onNavClick() {
    this.sidebarService.closeOnMobile();
  }

  openChangePasswordModal() {
    this.sidebarService.closeOnMobile();
    this.isPasswordModalOpen.set(true);
  }

  closeChangePasswordModal() {
    this.isPasswordModalOpen.set(false);
  }

  getRoleName(role?: string): string {
    const roleMap: Record<string, string> = {
      'SUPER_ADMIN': '최고관리자',
      'MANAGER': '매니저',
      'EMPLOYEE': '직원'
    };
    return role ? (roleMap[role] || role) : '';
  }
}
